var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.75C9.48438 19.75 7.1875 18.4375 5.92969 16.25C4.67188 14.0898 4.67188 11.4375 5.92969 9.25C7.1875 7.08984 9.48438 5.75 12 5.75C14.4883 5.75 16.7852 7.08984 18.043 9.25C19.3008 11.4375 19.3008 14.0898 18.043 16.25C16.7852 18.4375 14.4883 19.75 12 19.75ZM11.3438 15.1562C11.3438 15.5391 11.6172 15.8125 12 15.8125C12.3555 15.8125 12.6562 15.5391 12.6562 15.1562V13.4062H14.4062C14.7617 13.4062 15.0625 13.1328 15.0625 12.75C15.0625 12.3945 14.7617 12.0938 14.4062 12.0938H12.6562V10.3438C12.6562 9.98828 12.3555 9.6875 12 9.6875C11.6172 9.6875 11.3438 9.98828 11.3438 10.3438V12.0938H9.59375C9.21094 12.0938 8.9375 12.3945 8.9375 12.75C8.9375 13.1328 9.21094 13.4062 9.59375 13.4062H11.3438V15.1562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTask);
export default __webpack_public_path__ + "static/media/add-task.deb11e8d0a913287f02141c7385f6a38.svg";
export { ForwardRef as ReactComponent };